<template>
	<div v-if="is_logged_in"  class="home">
		<div class="col-md-offset-1 col-md-10">
			<div class="mb-4 pb-4  panel panel-default drop-shadow">
				<div class="panel-heading panel-grey text-left">
					WELCOME
				</div>
				&nbsp;<br>
				<h3>Welcome to FiledSafely</h3>
				
				<br>
				To view files you have sent or received, click on the FILES option on the menu bar above.

				<br><br>

				<div class="" style="clear:both;">

					<div class="mb-8 col-md-8 text-left">
                        <div class="mt-1 sm:mt-0 sm:col-span-2">
                            <div
                                class="d-flex justify-center p-6"
                                style="border: 2px dashed #888888; border-radius: 4px;;"
                                @dragover.prevent="dropZoneActive = true"
                                @dragenter.prevent="dropZoneActive = true"
                                @dragleave.prevent="dropZoneActive = false"
                                @drop.prevent="handleFileDrop"
                            >
                                <div class="text-center">
                                    <svg  class="mx-auto"  style="width:48px; color:#888888;"
                                            stroke="currentColor"   fill="none"
                                            viewBox="0 0 48 48"
                                            aria-hidden="true"
                                    >
                                        <path
                                            d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                                            stroke-width="2"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                    <div class="d-flex justofytext-sm text-gray-600">
                                        <label for="file-upload"
                                                class=""
                                        >
                                            <span @click="chooseFile">Choose a file</span>
                                            <input id="images"
                                                name="images"
                                                type="file"
                                                ref="file"
                                                multiple="multiple"
                                                @change="chooseFileSelected"
                                            />
                                        </label>
                                        <p class="pl-1">or drag and drop</p>
                                    </div>
                                    <p class="text-xs text-gray-500">
                                        Select up to 20 files, up to 50MB each
                                    </p>
                                </div>
                            </div>
                        </div>
					</div>
					<div class="col-md-4">
						<label class="control-label text-left" style='padding-top:7px; width:100%;' >
                            <!-- Files list -->
                            <div v-if="upload_files_list != null" class="">
                                <div v-for="file in upload_files_list" :key="file.name" class="py-1">
                                    <svg fill="#888888" height="14px" width="14px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512.001 512.001" xml:space="preserve" stroke="#888888"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path d="M463.996,126.864L340.192,3.061C338.231,1.101,335.574,0,332.803,0H95.726C67.724,0,44.944,22.782,44.944,50.784v410.434 c0,28.001,22.781,50.783,50.783,50.783h320.547c28.002,0,50.783-22.781,50.783-50.783V134.253 C467.056,131.482,465.955,128.824,463.996,126.864z M343.255,35.679l88.127,88.126H373.14c-7.984,0-15.49-3.109-21.134-8.753 c-5.643-5.643-8.752-13.148-8.751-21.131V35.679z M446.158,461.217c0,16.479-13.406,29.885-29.884,29.885H95.726 c-16.479,0-29.885-13.406-29.885-29.885V50.784c0.001-16.479,13.407-29.886,29.885-29.886h226.631v73.021 c-0.002,13.565,5.28,26.318,14.871,35.909c9.592,9.592,22.345,14.874,35.911,14.874h73.018V461.217z"></path> </g> </g> <g> <g> <path d="M275.092,351.492h-4.678c-5.77,0-10.449,4.678-10.449,10.449s4.679,10.449,10.449,10.449h4.678 c5.77,0,10.449-4.678,10.449-10.449S280.862,351.492,275.092,351.492z"></path> </g> </g> <g> <g> <path d="M236.61,351.492H135.118c-5.77,0-10.449,4.678-10.449,10.449s4.679,10.449,10.449,10.449H236.61 c5.77,0,10.449-4.678,10.449-10.449S242.381,351.492,236.61,351.492z"></path> </g> </g> <g> <g> <path d="M376.882,303.747H135.119c-5.77,0-10.449,4.678-10.449,10.449c0,5.771,4.679,10.449,10.449,10.449h241.763 c5.77,0,10.449-4.678,10.449-10.449C387.331,308.425,382.652,303.747,376.882,303.747z"></path> </g> </g> <g> <g> <path d="M376.882,256H135.119c-5.77,0-10.449,4.678-10.449,10.449c0,5.771,4.679,10.449,10.449,10.449h241.763 c5.77,0,10.449-4.678,10.449-10.449C387.331,260.678,382.652,256,376.882,256z"></path> </g> </g> <g> <g> <path d="M376.882,208.255H135.119c-5.77,0-10.449,4.678-10.449,10.449c0,5.771,4.679,10.449,10.449,10.449h241.763 c5.77,0,10.449-4.678,10.449-10.449S382.652,208.255,376.882,208.255z"></path> </g> </g> </g
                                    ></svg>&nbsp;<span>{{ (file.size / 1024 / 1024).toFixed(1) }}&nbsp;mb</span
                                    >&nbsp;<small>{{ file.name }}</small>
                                </div>
                            </div>
                            <!-- End files list -->
						</label>
					</div>

				</div>

				<div class="py-4" style="padding-top:10px; clear:both;">
                    <center>
                        <button  v-if="is_uploading == false" 
                                @click="uploadFiles()"  
                                :disabled="is_ok_to_send == false"
                                name="button"  type="submit"  
                                class="btn btn-primary btn-block"  
                                style="width:200px; border:2px solid black; margin:10px;"
                        >
                            <font size=+1><b>Upload Files</b></font>
                        </button>


                        <button v-else
                                :disabled=true
                                class="btn btn-primary btn-block"  
                                style="width:200px; border:2px solid black; margin:10px;"
                        >
                            <font size=+1><b>Uploading ...</b></font>
                        </button>
                    </center>
                </div>


            </div>
		</div>
	</div>

	<div v-else               class="home">
		<div class="col-md-12">

			<!-- **************************************************
			     * Welcome Panel                                  *
			     ************************************************** -->
			<!-- DESKTOP -->
			<div  v-if="$mq !== 'mobile'">
				<!--
                <div class="panel-heading panel-grey text-left">
					WELCOME
				</div>
				<br>&nbsp;
                -->

				<font size=+4 style="not-text-transform: uppercase; color:white;
                                     text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;">
					<b>
                    <span><span style="color:orange">Protect</span> your copyright and <span style="color:orange">secure</span> your agreements</span>
                    </b>
				</font><br>
				<font size=+2 style="color:lightgrey;
                                     text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;">
                    powered and secured by block-chain technology
				</font>

				<br>&nbsp;

                <div class="text-left" style='margin-left:auto; margin-right:auto; width:80%; 
                                              margin-top:10px; margin-bottom:20px;
                                              padding:10px; font-size:20px;
                                              color:white; text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;'>
                    FiledSafely is the perfect partner for:
                    <center>
                        <table style='width:80%; margin:10px;'>
                            <tr>
                                <td style='width:50%; padding:5px;'>&bull; Confidentiality Agreements</td>
                                <td style='width:50%; padding:5px;'>&bull; Legal agreements and Contracts</td>
                            </tr>
                            <tr>
                                <td style='padding:5px;'>&bull; Creative Pitches</td>
                                <td style='padding:5px;'>&bull; Design briefs</td>
                            </tr>
                            <tr>
                                <td style='padding:5px;'>&bull; Audio tracks, Music, Lyrics</td>
                                <td style='padding:5px;'>&bull; Scripts and manuscripts</td>
                            </tr>
                            <tr>
                                <td style='padding:5px;' colspan=2>... and many more</td>
                            </tr>
                        </table>
                    </center>
				</div>


				<div v-if="1==1"
                     class="panel panel-default drop-shadow"  style="background-color:rgba(255, 255, 255, 0.8) !important; 
                                                                     margin-left:auto; margin-right:auto; width:80%">
					<center>
						<div class="text-left" style='margin-left:auto; margin-right:auto; padding:10px; font-size:16px;'>
                            <b>Using FiledSafely could not be simpler.</b> 
                            <br><br>
                            To register your data, just email to <b>{{ prot_em }}</b> - and that's it. Simple!
                            <br><br>
                            If you are a new user an account will be automatically created for you.
                            <br><br>
                            Alternatively, for example, if you are sending your data to a publisher, just "cc" <b>{{ prot_em }}</b> when doing so. 
                            This will register and store your data, and FiledSafely will automatically let your recipients know you have protected your data.
                            <br><br>

                            See what our <router-link to="/testimonials">customers say</router-link>!

                            <center>
                                <button  @click="get_started()"  name="button"  type="submit"  class="btn btn-warning btn-block"  style="width:320px; border:2px solid black; margin:10px;">
                                    <font size=+1><b>Click here to get started</b></font>
                                </button>
                            </center>
						</div>
					</center>                            
				</div>

				<br>&nbsp;
				<br>&nbsp;
			</div>

			<!-- MOBILE -->
			<div  v-if="$mq === 'mobile'">
                <!--
				<div class="panel-heading panel-grey text-left">
					WELCOME
				</div>
				<br>&nbsp;
                -->

				<font size=+2 style="text-transform: uppercase; color:white;
                                     text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;">
					<b>
                    <span><span style="color:orange">Protect</span> your copyright and <span style="color:orange">secure</span> your agreements</span>
                    </b>
				</font><br>
				<font size=+0 style="color:lightgrey;
                                     text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;">
                    powered and secured by block-chain technology
				</font>

				<br>&nbsp;

                <div class="text-left" style='margin-left:auto; margin-right:auto; width:90%; 
                                              margin-top:10px; margin-bottom:20px;
                                              padding:10px; font-size:18px;
                                              color:white; text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;'>
                    FiledSafely is the perfect partner for:
                    <center>
                        <table style='width:100%; margin:10px;'>
                            <tr>
                                <td style='width:50%; padding:5px;'>&bull; Confidentiality Agreements</td>
                                <td style='width:50%; padding:5px;'>&bull; Legal agreements and Contracts</td>
                            </tr>
                            <tr>
                                <td style='padding:5px;'>&bull; Creative Pitches</td>
                                <td style='padding:5px;'>&bull; Design briefs</td>
                            </tr>
                            <tr>
                                <td style='padding:5px;'>&bull; Audio tracks, Music, Lyrics</td>
                                <td style='padding:5px;'>&bull; Scripts and manuscripts</td>
                            </tr>
                            <tr>
                                <td style='padding:5px;' colspan=2>... and many more</td>
                            </tr>
                        </table>
                    </center>
				</div>
				<br>

				<div v-if="1==1"
                     class="panel panel-default drop-shadow"  style="background-color:rgba(255, 255, 255, 0.8) !important; 
                                                                     margin-left:auto; margin-right:auto; padding:5px;">
					<center>
						<div class="text-left" style='margin-left:auto; margin-right:auto; padding:10px; font-size:16px;'>
                            <b>Using FiledSafely could not be simpler.</b> 
                            <br><br>
                            To register your data, just email to <b>{{ prot_em }}</b> - and that's it. Simple!
                            <br><br>
                            If you are a new user an account will be automatically created for you.
                            <br><br>
                            Alternatively, for example, if you are sending your data to a publisher, just "cc" <b>{{ prot_em }}</b> when doing so. 
                            This will register and store your data, and FiledSafely will automatically let your recipients know you have protected your data.
                            <br><br>

                            See what our <router-link to="/testimonials">customers say</router-link>!

                            <center>
                                <button  @click="get_started()"  name="button"  type="submit"  class="btn btn-warning btn-block"  style="width:320px; border:2px solid black; margin:10px;">
                                    <font size=+1><b>Click here to get started</b></font>
                                </button>
                            </center>
						</div>
					</center>                            
				</div>
			</div>
		</div>
		
	</div>
</template>


<script>

export default {
	name: 'home',

	props: {
	},
	
	components: {
	},
	
	data() {
		return {
			env:                        process.env.VUE_APP_ENV,
			api_token:                  '',
            prot_em :                   'dummy@test.com',
			show_section:               3,

            dropZoneActive:             false,

            upload_files_list:          [],
            upload_files_list_count:    0,
            is_uploading:               false,
            has_uploaded:               false,
            max_size_allowed:           (50 * 1024 * 1024),
            //allowed_types:     [
            //    'image/jpg',
            //    'image/jpeg',
            //    'image/png',
            //    'image/gif',
            //],
		};
	},

	computed: {
		is_logged_in() {
			var status     = false;
			this.api_token = localStorage.getItem('api_token');
			
			if (this.api_token  &&  this.api_token.length == 64) {
				status = true;
			}
				
			return status;
		},

		user() {
			return this.$store.getters.USER;
		},

        got_files() {
            return (this.upload_files_list != [])
        },

        is_ok_to_send() {
            return (this.got_files)
        }
	},
	
	created() {
	},

	mounted() {
        this.prot_em  = 'prot';
        this.prot_em += 'ect';
        this.prot_em += '@';
        this.prot_em += 'fil';
        this.prot_em += 'edsafely.';
        this.prot_em += 'com';
    },
    
	destroyed() {
	},

	methods: {
		get_started() {
			this.$router.push({ path: 'get_started' });
		},


        chooseFile() {
            const fileInput = document.getElementById('images');
            fileInput.click();
        },
    
        chooseFileSelected(e) {
            this.handleFileDrop({ dataTransfer: document.getElementById('images') });
        },
    
        handleFileDrop(event) {
            const dropped_filelist = event.dataTransfer.files

            // Go through dropped files and handle pre-upload-checks
            for (let i = 0; i < dropped_filelist.length; i++) {
                let dropped_file = dropped_filelist.item(i)

                // Remove if already on the list
                this.upload_files_list = this.upload_files_list.filter(e => {
                    return e.name !== dropped_file.name;
                })

                // Add to list
                if (dropped_file.size < this.max_size_allowed ) {
                    //if ( this.allowed_types.includes(dropped_file.type.toLowerCase()) ) {
                        this.upload_files_list.push(dropped_file);
                    //}
                    //else {
                    //    console.log('File "' + dropped_file.name + '" not added - wrong type: ' + dropped_file.type);
                    //}
                }
                else {
                    console.log('File "' + dropped_file.name + '" not added - too big: ' + dropped_file.size);
                }
            }
        },
      
        uploadFiles() {
            this.is_uploading = true;

            const token = getStorage('token')
            const headers = {
                "Content-Type": "multipart/form-data",
                "Authorization": "Bearer " + token,
            }


            let formData = new FormData()

            formData.append("title", this.title)
            formData.append("description", this.description)
            formData.append("is_preview", this.preview)
            formData.append("is_members_only", this.membership)
            this.upload_files_list.forEach( file => {
                formData.append("photos[]", file);
            });
    
            /*
                            'title'           => 'required|string|min:4|max:500',
                            'description'     => 'required|string|min:4|max:8000',
                            'cover'           => 'required|mimes:jpg,gif,png|max:20000',
                            'video'           => 'required|mimes:mp4,avi,mov,mkv,m4v,wmv|max:100000',
                            'is_preview'      => 'required|in:0,1',
                            'is_members_only' => 'required|in:0,1',
                            'price'           => 'sometimes|numeric|between:0.00,99.99',
            */
            //console.log('form data:')
            //for (var pair of formData.entries()) {
            //    console.log(pair[0]+ ', ' + pair[1]); 
            //}
    
            axios.post(this.api_url + '/api/admin/photosets/upload', formData, {headers: headers}).then((res) => {
                //console.log('upload result = ', res)
                res.data.files;
                res.status;

                this.has_uploaded            = true;
                this.is_uploading            = false;
                this.upload_files_list_count = this.upload_files_list.length;
                this.upload_files_list       = [];

                this.show_message = true;
            });
        },
    },
}

</script>
